import React from 'react';
// Styles
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { syntaxHighlight } from '@src/components/syntax-highlight';
import SyntaxHighlighter from 'react-syntax-highlighter';
import atomOneLight from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-light';
// Types
import { UsersIntergrationFormProps } from './types';
// Components
import CopyToClipboardButton from '@src/components/copy-clipboard';

const RentmanBigCommerceForm: React.FC<UsersIntergrationFormProps> = ({
  config,
  loading,
  statusText,
  errorObject,
  formSubmitted,
  handleBigcommerceValueChanged,
  handleFormSubmit,
}) => {
  return (
    <>
      <Card>
        <Card.Header>Bigcommerce connection</Card.Header>
        <Card.Body>
          <Form>
            <Form.Group className="mb-3" controlId="users_integrations_url">
              <Form.Label>URL</Form.Label>
              <Form.Control type="url" value="https://api.bigcommerce.com" disabled />
            </Form.Group>
            <Form.Group className="mb-3" controlId="apiKey">
              <Form.Label>Access token</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Access Token"
                value={config.bigcommerce.users_integrations_api_data.apiKey}
                onChange={handleBigcommerceValueChanged}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="apiSecret">
              <Form.Label>API path</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter API Path"
                value={config.bigcommerce.users_integrations_api_data.apiSecret}
                onChange={handleBigcommerceValueChanged}
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              disabled={loading['bigcommerce'] === true ? true : false}
              onClick={(e) => handleFormSubmit(e, 'bigcommerce')}
            >
              Save
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <Card className="mt-4">
        <Card.Header>Debug</Card.Header>
        <Card.Body>
          {loading['bigcommerce'] && (
            <>
              <Spinner animation="border" role="status" size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </>
          )}

          {formSubmitted && (
            <>
              Connection status:
              <pre dangerouslySetInnerHTML={{ __html: syntaxHighlight(JSON.stringify(statusText['bigcommerce'], undefined, 4)) }} />
              {errorObject.bigcommerce && (
                <>
                  <div>
                    <SyntaxHighlighter language="json" style={atomOneLight}>
                      {JSON.stringify(errorObject.bigcommerce, null, 2)}
                    </SyntaxHighlighter>
                  </div>
                  <CopyToClipboardButton textToCopy={JSON.stringify(errorObject.bigcommerce, null, 2)} buttonText="Copy" successText="Copied!" />
                </>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default RentmanBigCommerceForm;
